import React, {useEffect, useState} from "react";
import { useTranslation, Trans } from "react-i18next";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { callAPI, log, isValidPassword} from "../../utils/utils";

import PublicPage from "../../elements/PublicPage/PublicPage";
import TextField from "../../elements/TextField/TextField";
import Button from "../../elements/Button/Button";


const PasswordRecoveryConfirmPage = () => {

  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [ keyValid, setKeyValid ] = useState(false);
  const [ password, setPassword ] = useState("");
  const [ passwordRepeat, setPasswordRepeat ] = useState("");
  const [ working, setWorking ] = useState(false);
  const [ passwordInvalid, setPasswordInvalid ] = useState(false);
  const [ passwordRepeatInvalid, setPasswordRepeatInvalid ] = useState(false);

  const { recoverKey } = useParams();

  const handleSubmit = (e) => {
    log("handleSubmit");
    e.preventDefault()
    if (!isValidPassword(password)) {
      setPasswordInvalid(true);
      return;
    }

    if (password !== passwordRepeat) {
      setPasswordRepeatInvalid(true);
      return;
    }

    setWorking(true);
    setPasswordInvalid(false);
    setPasswordRepeatInvalid(false);


    callAPI("recovery/confirm", "POST", {key: recoverKey, password: password}).then(() => {
      enqueueSnackbar(t('ResetPassword.Success'), {variant:'success', autoHideDuration: 5000});
      navigate("/login", { replace: true });
    }).catch(() => {
      enqueueSnackbar(t('ResetPassword.Error'), {variant:'error', autoHideDuration: 10000});
      navigate("/login", { replace: true });
    });
  }

  useEffect(() => {
    callAPI("recovery/check", "POST", {key: recoverKey}).then(() => {
      setKeyValid(true);
    }).catch(() => {
      enqueueSnackbar(t('ResetPassword.Error'), {variant:'error', autoHideDuration: 10000});
      navigate("/login", { replace: true });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {keyValid && <PublicPage
        infoHeadline={t('ResetPassword.InfoHeadline')}
        infoText={t('ResetPassword.InfoText')}
        contentHeadline={t('ResetPassword.FormHeadline')}
      >
        <form onSubmit={handleSubmit}>
          <TextField
            id="password"
            label={t('ResetPassword.Password')}
            type={'password'}
            autoFocus
            required
            fullWidth
            error={passwordInvalid}
            helperText={passwordInvalid? t("ResetPassword.PasswordError") : " "}
            onChange={(e) => {setPassword(e.target.value);setPasswordInvalid(false);}}
          />
          <TextField
            id="passwordRepeat"
            label={t('ResetPassword.PasswordRepeat')}
            type={'password'}
            autoFocus
            required
            fullWidth
            error={passwordRepeatInvalid}
            helperText={passwordRepeatInvalid? t("ResetPassword.PasswordRepeatError") : " "}
            onChange={(e) => {setPasswordRepeat(e.target.value);setPasswordRepeatInvalid(false);}}
          />
          <Button
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            working={working}
            className="public__submit"
          >
            <Trans>ResetPassword.Button</Trans>
          </Button>
        </form>
      </PublicPage>}
    </>
  );
}

export default PasswordRecoveryConfirmPage;